export { default as TabMenu } from './TabMenu'
export type { TabMenuProps, TabType } from './types'
